// Helper to access @nuxtjs/i18n instance
// This is a compatibility layer for non-component files that can't use useI18n()
const i18n = {
  global: {
    t: (key: string, params?: any) => {
      try {
        const nuxtApp = useNuxtApp()
        const i18nInstance = (nuxtApp as any).$i18n
        if (i18nInstance) {
          return i18nInstance.t(key, params)
        }
      } catch (e) {
        // Fallback if useNuxtApp is called outside of context
      }
      return key
    }
  }
}

export default i18n
